import React from 'react';

import { CoreLink } from '@uncinc/react-drupal-core';

import { Button, Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { useTranslation } from 'react-i18next';

const NavigationMainMenuSubComponentKVNL = ({ item }) => {
  const { t } = useTranslation();

  const renderMenuRecursively = (newSubTree) => {
    const itemToMap = newSubTree || item;
    return itemToMap.get('subtree').map((subItem, i) => {
      const subItemHref = subItem.getIn(['link', 'url']);
      const subItemTitle = subItem.getIn(['link', 'title'], '');

      if (newSubTree) {
        return (
          <li key={`menu--main--sub-menu-item-${subItemTitle}:${subItemHref}`}>
            <div className={`NavigationMainMenuDesktop--kvnl--subMenu__item ${newSubTree ? '' : 'NavigationMainMenuDesktop--kvnl--subMenu__item--top'}`}>
              <CoreLink
                className={`NavigationMainMenuDesktop--kvnl--subMenu__items__title overlapping-link ${newSubTree ? '' : 'NavigationMainMenuDesktop--kvnl--subMenu__items__title--top'}`}
                to={subItemHref}
              >
                <span>
                  {subItemTitle} <div className="icon icon-chevron-right" />
                </span>
              </CoreLink>
            </div>
          </li>
        );
      }

      return (
        <div className="col-12" key={`menu--main--sub-menu-item-${subItemTitle}:${subItemHref}`}>
          <div className={`NavigationMainMenuDesktop--kvnl--subMenu__item ${newSubTree ? '' : 'NavigationMainMenuDesktop--kvnl--subMenu__item--top'}`}>
            <div
              className={`NavigationMainMenuDesktop--kvnl--subMenu__items__title overlapping-link ${newSubTree ? '' : 'NavigationMainMenuDesktop--kvnl--subMenu__items__title--top'}`}
            >
              <span className="NavigationMainMenu__subMenuPrefix">
                <span>Kennisaanbod op </span>
                <strong>{subItemTitle.toLowerCase()}</strong>
              </span>
            </div>
          </div>
          <ul
            className={`${
              i === 0
                ? 'NavigationMainMenuDesktop--kvnl--subMenu__items__list'
                : 'NavigationMainMenuDesktop--kvnl--subMenu__items__list__2'
            }`}
          >
            {subItem.get('subtree').size > 0 && renderMenuRecursively(subItem)}
          </ul>
        </div>
      );
    });
  };

  return (
    <div className="NavigationMainMenuDesktop--kvnl--subMenu">
      <Container className="NavigationMainMenuDesktop--kvnl--subMenu__container">
        <div className="row">
          <div className="col-12">
            <div className="NavigationMainMenuDesktop--kvnl--subMenu__items">
              <div className="row">{renderMenuRecursively()}</div>
            </div>
          </div>
        </div>
      </Container>
      <div className="NavigationMainMenuDesktop--kvnl--subMenu__bottom">
        <Container>
          <Button className="Button--ghost">
            {t('menu.close_offers')}
            <div className="icon icon-cross" />
          </Button>
        </Container>
      </div>
    </div>
  );
};

export default NavigationMainMenuSubComponentKVNL;
